import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { AsyncLockScreenModal } from './async';
import type { LockScreenModalProps } from './types';

export const LockScreenModal = (props: LockScreenModalProps) => (
	<JSErrorBoundary
		id="jiraPremiumEotModal"
		fallback="unmount"
		packageName="jiraLockScreenExperiment"
		// eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
		teamName="jlove-makkuro"
	>
		<ContextualAnalyticsData
			sourceName="jiraPremiumEotModal"
			sourceType={SCREEN}
			attributes={{
				...props.analyticsAttributes,
				predunningDaysLeft: props.predunningDaysLeft,
				usageOverLimit: props.usageOverLimit,
				isBillingAdmin: props.isBillingAdmin,
				isBillingUser: props.isBillingUser,
			}}
		>
			<AsyncLockScreenModal {...props} />
		</ContextualAnalyticsData>
	</JSErrorBoundary>
);
